<template>
  <div v-if="section !== ''">
    <icon-box-zzim :section="section" :is-on="isOn" :title="zzimTitle" :toggle-fn="toggle" :zzim-icon="zzimIcon" :aria-label="ariaLabelTitle"></icon-box-zzim>
  </div>
</template>

<script>
import IconBoxZzim from '@/components/play/IconBoxZzim'
import utils from '@/common/util/utils'
import { getEventListByType } from '@/common/util/event.util'
import { get } from 'lodash'
import { apiRequest, commonRequestInstanceToAxiosRequestInfo } from '@/common/api/api.service'
import {
  MSG_COMPLETE_ADD_ZZIM_MOVIE,
  MSG_COMPLETE_ADD_ZZIM_PROGRAM, MSG_COMPLETE_DELETE_ZZIM_MOVIE,
  MSG_COMPLETE_DELETE_ZZIM_PROGRAM
} from '@/common/constant'
export default {
  name: 'IconBoxZzimWithEvent',
  components: { IconBoxZzim },
  props: {
    zzim: {
      type: String
    },
    eventList: {
      type: Array
    },
    isZzimTitle: {
      type: String
    }
  },
  data () {
    return {
      isOn: false,
      device: utils.cookies.getDevice(),
      section: ''
    }
  },
  computed: {
    zzimIcon () {
      if (this.section === 'program') {
        return this.isOn ? 'un-subscribe-button' : 'subscribe-button'
      } else {
        return this.isOn ? 'un-like-button' : 'like-button'
      }
    },
    ariaLabelTitle () {
      return '관심'
    },
    zzimTitle () {
      return this.isZzimTitle === 'y' ? this.ariaLabelTitle : ''
    }
  },
  methods: {
    getSubscribeMessageBySection () {
      let subscripMesssage = ''
      if (this.section === 'program') {
        subscripMesssage = MSG_COMPLETE_ADD_ZZIM_PROGRAM
      }
      if (this.section === 'movie') {
        subscripMesssage = MSG_COMPLETE_ADD_ZZIM_MOVIE
      }
      return subscripMesssage
    },
    getUnSubscribeMessageBySection () {
      let unSubscripMessage = ''
      if (this.section === 'program') {
        unSubscripMessage = MSG_COMPLETE_DELETE_ZZIM_PROGRAM
      }
      if (this.section === 'movie') {
        unSubscripMessage = MSG_COMPLETE_DELETE_ZZIM_MOVIE
      }
      return unSubscripMessage
    },
    ifDintLoginThenGoLogin () {
      return this.device === 'mobile' && utils.cookies.getCredential() === 'none'
    },
    toggle () {
      if (this.ifDintLoginThenGoLogin()) {
        this.$router.replace(`/login?referer=${this.$route.fullPath.replace(location.origin, '')}`)
        return
      }
      const { onZzimEvent, offZzimEvent } = getEventListByType(this.eventList)
      let event = this.isOn ? offZzimEvent : onZzimEvent
      apiRequest(commonRequestInstanceToAxiosRequestInfo({
        url: 'https://' + get(event, 'url', '').replace(location.protocol, ''),
        method: get(event, 'method', ''),
        needCommonParams: true,
        needCredential: true,
        data: get(event, 'bodyjson', {})
      })).then(({ data }) => {
        const resultCode = get(data, 'resultcode', '200')
        if (resultCode === '500') {
          const message = get(data, 'resultmessage', '잠시 후 다시 시도해 주세요')
          utils.alert(message)
        } else {
          this.$nextTick(() => {
            this.isOn = !this.isOn
            this.$toast({ message: this.isOn ? this.getSubscribeMessageBySection() : this.getUnSubscribeMessageBySection() })
          })
        }
      })
    },
    init () {
      this.isOn = this.zzim === 'y'
      const { onZzimEvent } = getEventListByType(this.eventList)
      this.section = get(onZzimEvent, 'bodyjson.contenttype', '')
    }
  },
  created () {
    this.init()
  }
}
</script>
